import React from "react";

// Inline image inside an assistant message.
// - Sized responsively to fit the chat bubble width.
// - Clicking the image opens the full original in the host's default browser
//   (WebView2 surfaces target="_blank" as a NewWindowRequested event).
const ZoomableImage = ({ src, alt }) => {
  if (!src) return null;
  return (
    <a
      href={src}
      target="_blank"
      rel="noopener noreferrer"
      className="md-image-link"
      title="Open full size in browser"
    >
      <img
        src={src}
        alt={alt || ""}
        className="md-image"
        loading="lazy"
      />
    </a>
  );
};

export default ZoomableImage;
